module.exports = __webpack_public_path__ + "img/broadcast_architecture_img.72c74416.png";